module.exports = __webpack_public_path__ + "img/1799_logo_h.1d591bb6.png";